import { Box, useMediaQuery } from '@mui/material'
import gaiaTheme from '../../../../../root-components/theme';
import { PageOuterContainer } from '../../../../../root-components/layouts/page-outer-container';
import { SettingsMobileNavbar } from '../../../../../root-components/navigation/settings-mobile-navbar';
import { PageHeading } from '../../../../presentation-components/display-elements-components/page-heading';
import { FileUploadProgress } from './steps/file-upload-progress';

export const FileUploadProgressPage = () => {
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  return (
    <PageOuterContainer>
      {isMobileMode && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      <PageHeading
        title='Import data'
        hasTabs={false}
      />
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 5 }}>
        <Box sx={{ width: '100%', maxWidth: 880 }}>
          <FileUploadProgress />
        </Box>
      </Box>
    </PageOuterContainer>
  )
}

